import name from './name'

const selectSliceData = state => state[name]
const selectAssessmentDetails = state => selectSliceData(state)
const selectAssessmentStatus = state => selectSliceData(state).assessmentStatus
const selectMetaSkillsStatus = state => selectSliceData(state).metaSkillsStatus
const selectAssessmentReport = state => selectSliceData(state).assessmentReport

export {
  selectAssessmentDetails,
  selectAssessmentStatus,
  selectMetaSkillsStatus,
  selectAssessmentReport
}
